import { ValueOfKey } from '../../utils-types';

export const FOOD_TAG_NAME = {
  PROTEIN: 'Protein',
  CARBOHYDRATE: 'Carbohydrate',
  FAT: 'Fat',
  VEGGIE: 'Veggie',
  FRUIT: 'Fruit',
  BEVERAGE: 'Beverage',
  SUPPLEMENT: 'Supplement',
  CONDIMENTS: 'Condiments',
  OTHER: 'Other',
} as const;

export type FoodTagName = ValueOfKey<typeof FOOD_TAG_NAME>;
